// extracted by mini-css-extract-plugin
module.exports = {"pulse":"styles_pulse__25SJP","greenPulse":"styles_greenPulse__3obo_"};